export enum MeetingPlatformType {
    GOOGLE_MEET = 'Google Meet',
    ZOOM = 'Zoom',
    MICROSOFT_TEAMS = 'Microsoft Teams',
    WEBEX = 'Webex',
    BLUEJEANS = 'BlueJeans',
}
